import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  getTenantDetailsWithTenantNameActionHandler,
  preLoginActionHandler,
} from "../../store/actions/actionHandlers/loginActionHandler";

const CheckTenantPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tenantName = localStorage.getItem("tenantName");
  const { token } = useParams();
  console.log("Captured token:", token);

  useEffect(() => {
    if (location.pathname !== undefined || location.pathname !== null) {
      let splitTenantName = location.pathname.split("/");
      let [, tenantSlugName, ...rest] = splitTenantName;
      if (tenantSlugName?.includes("aadlogin")) {
        let splitURL = location.pathname.split("aadlogin");
        navigate(`/aadlogin${splitURL[1]}`);
      } else {
        dispatch(
          getTenantDetailsWithTenantNameActionHandler(
            tenantName,
            undefined,
            navigate,
            false,
            true
          )
        );
      }
    }
  }, [dispatch, location.pathname, navigate]);

  return <></>;
};

export default CheckTenantPage;
